export default __webpack_public_path__ + "static/media/icon-workpack-scheduled.69a93b42.svg";